export enum Roles {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  APPLICANT = 'APPLICANT',
  CENTRAL_ADMIN = 'CENTRAL_ADMIN',
  REGION_ADMIN = 'REGION_ADMIN',
  // INSPECTOR = 'INSPECTOR',
}
